import { RootState } from 'redux/reducers/rootReducer';

const citiesSelector = (state: RootState) => state.region.cities;
const isCitiesLoadingSelector = (state: RootState) =>
  state.region.isCitiesLoading;
const statesSelector = (state: RootState) => state.region.states;
const isStatesLoadingSelector = (state: RootState) =>
  state.region.isStatesLoading;
const countriesSelector = (state: RootState) => state.region.countries;
const isCountriesLoadingSelector = (state: RootState) =>
  state.region.isCountriesLoading;
const countryCitiesSelector = (state: RootState) => state.region.countryCities;
const isCountryCitiesLoadingSelector = (state: RootState) =>
  state.region.isCountryCitiesLoading;

export {
  citiesSelector,
  statesSelector,
  countriesSelector,
  countryCitiesSelector,
  isCitiesLoadingSelector,
  isStatesLoadingSelector,
  isCountriesLoadingSelector,
  isCountryCitiesLoadingSelector,
};
